import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './key-highlight-item.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class KeyHighlightItem extends s {
    constructor() {
        super(...arguments);
        this.itemNumber = 1;
        this.isRtl = false;
        this.containerClassNames = '';
    }
    render() {
        this.containerClassNames = getStyleClassNames({
            isRtl: this.isRtl,
        });
        return x `<div class="key-highlight-item ${this.containerClassNames}"><div class="item-number"><div class="number-circle"><div class="number">${this.itemNumber}</div></div></div><div class="item-description"><slot></slot></div></div>`;
    }
}
KeyHighlightItem.styles = css_248z;
__decorate([
    n({ type: Number })
], KeyHighlightItem.prototype, "itemNumber", void 0);
__decorate([
    n({ type: Boolean })
], KeyHighlightItem.prototype, "isRtl", void 0);
customElements.define('key-highlight-item', KeyHighlightItem);

export { KeyHighlightItem };
